import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {Divider, Typography, useTheme} from "@mui/material";
import {PD_MD, PD_SM, PD_XLG} from "@/shared/dimens";
import {white} from "@/shared/colors";
import {FooterSectionData, SiteTemplate} from "../../types";

export function FooterSection(props: { data: FooterSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  return <div style={{backgroundColor: "#0E0025"}}>
    <SectionContainer>
      <StyledBoxRow style={{alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: PD_XLG}}>
        <StyledBoxColumn style={{gap: PD_SM, maxWidth: 320}}>
          {props.data.logo
            ? <img src={props.data.logo} style={{width: 120, aspectRatio: 1, objectFit: "contain"}}/>
            : null}
          {props.data.tagline
            ? <Typography style={{color: white, opacity: 0.7, lineHeight: 1.7}}>{props.data.tagline}</Typography>
            : null}
        </StyledBoxColumn>
        {props.data.links?.length > 0
          ? <StyledBoxRow style={{flexWrap: "wrap", gap: PD_MD}}>
            {props.data.links.map((link, i) =>
              <Typography key={i}>
                <a href={link.url} style={{color: white, opacity: 0.7, textDecoration: "none"}}>
                  {link.text}
                </a>
              </Typography>
            )}
          </StyledBoxRow>
          : null}
      </StyledBoxRow>
      <Divider style={{borderColor: "rgba(255,255,255,0.15)", margin: `${PD_XLG}px 0 ${PD_MD}px`}}/>
      <StyledBoxRow style={{alignItems: "center", opacity: 0.5}}>
        {props.data.copyrightText
          ? <Typography variant={"body2"} style={{color: white}}>
            {props.data.copyrightText}
          </Typography>
          : null}
        <StyledSpan/>
        <a href={"https://dentwyze.in"}>
          <StyledBoxColumn style={{gap: 0}}>
            <Typography variant={"caption"} style={{color: white}}>Powered by</Typography>
            <img src={"/images/dentwyze_logotype_w.svg"} style={{height: 20}}/>
          </StyledBoxColumn>
        </a>
      </StyledBoxRow>
    </SectionContainer>
  </div>;
}
